import React, { useEffect, useState } from "react";
//import Plotly from 'plotly.js-dist';
import createPlotlyComponent from "react-plotly.js/factory";

const Plot = createPlotlyComponent(window.Plotly);


export type StackedPlotConfig = {
    title: string;
    traces: any[]
}

  interface Props {
    config: StackedPlotConfig | null,
    onClick?: (depth: number) => void
  }

const StackedPlot = ({ config, onClick }: Props) => {
    const [plotConfig, setPlotConfig] = useState<any>(null);

    useEffect(() => {
        setPlotConfig(config);
    }, [config]);

    return (
      <>
      {
        plotConfig &&
        <Plot
            config={{
              displayModeBar: false,
              responsive: true
            }}            
            data={plotConfig.traces}
            layout={plotConfig.layout}
            useResizeHandler={true}
            style={{width: "100%", height: "100%"}}
            onClick={(e:any) => {
              if(e.points.length && onClick) {
                // convert the clicked poisition to data position
                const bb = e.event.target.getBoundingClientRect();
                const y = e.points[0].yaxis.p2d(e.event.clientY - bb.top);
                onClick(y);
              }
            }}
        />
      }
      </>
    );
        
}


export default StackedPlot;